<template>
  <div>
    <div class="hidden md:block">
      <div class="container mx-auto flex flex-wrap items-start py-10">
        <div v-for="col in 3" :key="col" class="p-3 w-1/3">
          <div v-for="image in imageCols[col-1]" :key="image.img" class="mb-5">
            <div class="bg-white shadow rounded-lg hover:shadow-lg">
              <a :href="image.img" target="_blank">
                <img class="opacity-90 hover:opacity-100 object-cover rounded-lg rounded-b-none" :src="image.min" :alt="image.description">
                <div class="p-4 text-center text-sm text-gray-700"
                  v-text="image.description">
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md:hidden">
      <div class="container mx-auto flex flex-wrap items-end py-10">
        <div v-for="image in images" :key="image.img" class="p-3 w-full sm:w-1/2 lg:w-1/3">
          <div class="bg-white shadow rounded-lg hover:shadow-lg">
            <a :href="image.img" target="_blank">
              <img class="opacity-90 hover:opacity-100 w-full h-64 object-cover rounded-lg rounded-b-none" :src="image.min" :alt="image.description">
              <div class="p-4 text-center text-sm text-gray-700"
                v-text="image.description">
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['category'],

  computed: {
    images() {
      let images = this.$store.state.originals;

      if (this.category) {
        images = images.filter(i => {
          return i.category == this.category;
        })
      }

      return images;
    },

    imageCols() {
      return this.images.reduce((cols, image, index) => {
        let col = index % 3;

        cols[col].push(image);

        return cols;
      }, [[], [], []]);
    },
  },
}
</script>
